/* Stylesheet */

.color_label {
  margin: 0px 12px 0px 0px;
  height: 16px;
  width: 16px;
  border-radius: 21px;
}
